import React from 'react';
import MobileDetect from 'mobile-detect';
import { PermissionsModalDesktop, PermissionsModalMobile } from '.';

export default ({ onAccept }) => {
    const md = new MobileDetect(navigator.userAgent);
    if (md.phone()) return <PermissionsModalMobile onAccept={onAccept} />;
    return <PermissionsModalDesktop onAccept={onAccept} />;
};
